import { makeAutoObservable } from 'mobx';

export default class RelatedCasesStore {
  search = '';
  alreadySearched = false;
  withResults = false;
  mobileSearchCoordinates = {};
  desktopMenuOpen = false;

  constructor() {
    makeAutoObservable(this);
  }

  setSearch = payload => {
    this.search = payload;
  };

  setAlreadySearched = payload => {
    this.alreadySearched = payload;
  };

  setWithResults = payload => {
    this.withResults = payload;
  };

  setMobileSearchCoordinates = payload => {
    this.mobileSearchCoordinates = payload;
  };

  setDesktopMenuOpen = payload => {
    this.desktopMenuOpen = payload;
  };
}
